import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrash = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Icon",
		d: "M9.66602 0.583008C10.6324 0.583008 11.4158 1.36666 11.416 2.33301V3.25H14.666V4.75H13.416V13.667C13.4158 14.6333 12.6324 15.417 11.666 15.417H4.33301C3.36677 15.4168 2.58318 14.6332 2.58301 13.667V4.75H1.33301V3.25H4.58301V2.33301C4.58318 1.36677 5.36677 0.583184 6.33301 0.583008H9.66602ZM4.08301 13.667C4.08318 13.8048 4.1952 13.9168 4.33301 13.917H11.666C11.804 13.917 11.9158 13.8049 11.916 13.667V4.75H4.08301V13.667ZM8.75 12.667H7.25V6H8.75V12.667ZM6.33301 2.08301C6.1952 2.08318 6.08318 2.19519 6.08301 2.33301V3.25H9.91602V2.33301C9.91584 2.19509 9.80398 2.08301 9.66602 2.08301H6.33301Z",
		fill: "currentColor"
	})
});
export default SvgTrash;
